<template>
  <div class="list">
    <div class="item-li" v-for="item in list" :key="item.t1" @click="toLink">
      <div class="item-t1">{{ item.t1 }}</div>
      <div class="item-t2">{{ item.t2 }}</div>
      <img class="item-to" src="../assets/img/right.png" alt="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data() {
    return {
      list: [
        { t1: '散播违法/敏感言论', t2: '商家发布的信息包含违法、政治敏感内容' },
        { t1: '人身攻击', t2: '咨询者存在辱骂、骚扰等语言或肢体上的不当行为' },
        {
          t1: '色情骚扰',
          t2: '商家发布的信息包含色情低俗内容或存在性强扰行为'
        },
        {
          t1: '虚假课程/证书',
          t2: '商家发布的信息与实际沟通不符。如报名、承诺等'
        },
        {
          t1: '违法/欺诈行为',
          t2: '商家发布的信息包含色情低俗内容或存在性强扰行为'
        },
        { t1: '其他违规行为', t2: '咨询者或公司存在以上列举类型之外的违规行为' }
      ]
    };
  },
  methods: {
    toLink() {
      this.$router.push({ name: 'complaint' });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.list {
  // width:100%;
  padding-left: 32px;
}
.item-li {
  width: 100%;
  /* height:132px; */
  padding: 0 32px 30px 0;
  border-bottom: 1px solid #e9edf1;
  position: relative;
  // box-sizing:border-box;
}
/* .item-li:after{
    display:block;
    content:'';
    height:1px;
    width:100%;
    position:absolute;
    top:0;
    left:0;
    right:0;
    background-color:#000;
  } */
.item-t1 {
  font-size: 30px;
  font-weight: bold;
  color: #06112a;
  line-height: 30px;
  padding-top: 32px;
}
.item-t2 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #8d939c;
  line-height: 32px;
  margin-top: 8px;
}
.item-to {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 34px;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/view/list.vue